import { BasicCommand } from "./BasicCommand";


import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicLayoutManager } from "../../view/BasicLayoutManager";
import { CommonDialogNames } from "../../view/CommonDialogNames";
import { BasicStandardOkDialogProperties } from "../../view/dialogs/BasicStandardOkDialogProperties";
import { Localize } from "@goodgamestudios/localization";

export class SMSCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_SERVER_MESSAGE;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            BasicLayoutManager.getInstance().showAdminDialog(CommonDialogNames.StandardOkDialog_NAME,
                new BasicStandardOkDialogProperties(
                    Localize.text("generic_alert_connection_failed_title"),
                    Localize.text("servershutdown_copy")));
        }
        return super.executeCommand(error, params);
    }
}

